import { Cell } from 'exceljs';

// Flashtalking rejects placement names containing smart punctuation (e.g. en dashes pasted from Sheets)
export const normalizePunctuation = (value: string): string =>
  value
    .trim()
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201C\u201D]/g, '');

export const toStatus = (statusCode: number) => {
  switch (statusCode) {
    case 0:
      return 'Pending';
    case 11:
      return 'Sent';
    case 20:
      return 'Confirmed';
    default:
      return 'Unknown';
  }
};

export const getValidPlatforms = (
  network: string,
  networkMap: Record<string, { platforms?: string[] }> | undefined
): string[] => {
  const platforms = [...(networkMap?.[network]?.platforms ?? [])];
  if (platforms.some(p => /^Audio.*$/.test(p))) {
    platforms.push('Audio Bonus');
  }
  if (platforms.some(p => /^Audio RTB.*$/.test(p))) {
    platforms.push('Audio RTB Bonus');
  }
  if (platforms.some(p => /^Streaming.*$/.test(p))) {
    platforms.push('Streaming Bonus');
  }
  if (platforms.some(p => /^Streaming RTB.*$/.test(p))) {
    platforms.push('Streaming RTB Bonus');
  }
  if (platforms.some(p => /^Display.*$/.test(p))) {
    platforms.push('Display Bonus');
  }
  return platforms;
};

// Date cells (including formula results) become UTC YYYY-MM-DD; everything else uses the cell's text
export const cellToImportText = (cell: Cell): string => {
  const value = cell.formula ? cell.result : cell.value;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }
  return cell.text ?? '';
};
